import React from 'react';
import AddNewWebsiteForm from './AddNewWebsiteForm';

type Props = {
    onValidDomain: (domain: string) => void;
};

export default function OnboardingStartScreen({ onValidDomain }: Props) {

    return (
        <div className="onboarding-start-screen">
            <img src="/images/illustration-robot-hand.svg" alt="onboarding start screen" />
            <h1>Welcome to Your SEO Toolbox!</h1>
            <div className="form-container">
                <h2>Let's set up your first website.</h2>
                <AddNewWebsiteForm
                    onValidDomain={onValidDomain}
                    title={"Add your website to start SEO monitoring.<br /> After setup, we'll start a <strong>full SEO analysis</strong> to identify issues and deliver clear <strong>how-to-fix</strong> guidance."}
                />
            </div>
        </div>
    );
}
